import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {ConversationBaseModel} from '../../../../../models/api/conversationModel';
import {AppState} from '../../../../../store/appState';
import {makeGetConversationsInboxes} from '../../../../../store/data/conversations/conversationsSelectors';
import {getUserId} from '../../../../../store/data/teammates/teammatesSelectors';
import {CellHoverIcons} from './cellHoverIcons';

/*
 * Props.
 */

interface CellHoverIconsContainerProps {
  conversation: ConversationBaseModel;
}

/*
 * Selectors.
 */

/** Returns an array with just the conversation from the props. */
function getConversations(_state: AppState, props: CellHoverIconsContainerProps) {
  return [props.conversation];
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CellHoverIconsContainerProps>()(() => ({
  inboxes: makeGetConversationsInboxes(getConversations),
  userId: getUserId,
}));

export const CellHoverIconsContainer = connect(mapStateToProps)(CellHoverIcons);
